export default [
    {
      path: '/awards',
      name: 'award-read',
      component: () => import('@/views/award/award-list/AwardList.vue'),
      meta: {
        resource: 'Award',
        action: 'read',
      },
    },
    
  ]
  